module.exports = __webpack_public_path__ + "img/fr7.f43a3189.png";